import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/index';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React, { Component, Fragment } from 'react';
import { DataCompte } from '../../data/DataCompte.jsx';
import { DataEcheancier } from '../../data/DataEcheancier.jsx';
import { DataReservation } from '../../data/DataReservation.jsx';
import { DataReservation_Echeancier_Stade } from '../../data/DataReservation_Echeancier_Stade.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxEcheancier } from '../ComboBox/ComboBoxEcheancier.jsx';
import { ComboBoxOperation_Echeancier_Stade } from '../ComboBox/ComboBoxOperation_Echeancier_Stade.jsx';
import { EUIDatePicker } from '../EUI/EUIDatePicker.jsx';
import { EUIDialog } from '../EUI/EUIDialog.jsx';
import { EUINumericField } from '../EUI/EUINumericField.jsx';
import { EUIPercentField } from '../EUI/EUIPercentageField.jsx';
import { DetailsListReservation_Echeancier_Stade } from '../List/DetailsListReservation_Echeancier_Stade.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './FicheEcheancier.css';

export class FicheReservation_Echeancier extends Component {

    static defaultProps = {
        estEcheancierVerrouille: false,
        idEcheancier: 0,
        idOperation: 0,
        idReservation: 0,
        nbADFReservation: 0,
        peutModifierBlocEcheancier: false,
        peutModifierChoixEcheancier: false,
        peutSupprimerBlocEcheancier: false,
        peutVerrouillerEcheancier: false,
        prixTTC: 0,
        estReservationVerrouillee: false,
        /* --- */
        onAnnuleFiche: () => null,
        onEnregistrementFiche: () => null,
    };

    static defaultState = {
        echeancier: {},
        estEcheancierValide: false,
        idEcheancierSelectionne: 0,
        monCompte: null,
        stadeSelectionne: {},
        stadesReservation: [],
        stamp: null, // Je m'en sers pour notifier la DetailsListReservation_Echeancier_Stade que l'échéancier a été mis à jour ; c'est pas le plus élégant, à voir si Eiffage ok pour refonte des mini-formulaires d'ajout stade + remplacement échéancier
        /* --- */
        enCoursDeTraitement: false,
        messageEnCoursTraitement: '',
        hideMessageBarError: true,
        errorMessage: '',
        hideMessageBarWarning: true,
        warningMessage: ''
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheReservation_Echeancier.defaultState };
    };

    _ajouterStade = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du stade'
        });

        const { idOperation, idReservation, idEcheancier } = this.props;
        const { stadeSelectionne } = this.state;
        const { idStade } = stadeSelectionne;

        const reservation_Echeancier_Stade = { idOperation, idReservation, idEcheancier, idStade };
        DataReservation_Echeancier_Stade._onEnregistrementReservation_Echeancier_Stades([reservation_Echeancier_Stade], true)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const state = {
                        stadeSelectionne: {},
                        stamp: Date.now(),
                    };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
    }

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement de l'échéancier"
        });

        const { idOperation, idEcheancier } = this.props;

        DataEcheancier._chargementEcheancier(idOperation, idEcheancier).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const reponseAPIobjet = responseFetch.reponseAPIobjet || {};
                const echeancier = reponseAPIobjet.echeancier || {};
                const state = { echeancier };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurPromise(this, retourVerif)
        });

    };

    _chargementMonCompte = () => {
        DataCompte._chargementMonCompte().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const monCompte = responseFetch.reponseAPIobjet;
                const state = { monCompte };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurPromise(this, retourVerif)
        });
    };

    _onChangeStadeSelectionne = (event, option, index, value, item) => {

        let stadeSelectionne = { ...item };

        const stadesPrecedents = this.state.stadesReservation
            .filter(stade => stade.pourcentageCumul < stadeSelectionne.pourcentageCumul)
            .sort((a, b) => b.pourcentageCumul - a.pourcentageCumul);
        const stadePrecedent = stadesPrecedents.length > 0 ? stadesPrecedents[0] : {};
        const pourcentageCumul = stadePrecedent.pourcentageCumul || 0;

        stadeSelectionne.pourcentageAvancementTravaux = stadeSelectionne.pourcentageCumul - pourcentageCumul;

        this.setState({ stadeSelectionne });

    };

    _remplacerEcheancier = () => {
        this._toggleDialog("Remplacement", false)();

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Remplacement de l'échéancier"
        });

        const { idOperation, idReservation } = this.props;
        const { idEcheancierSelectionne } = this.state;

        DataReservation._onRemplacementEcheancier(idOperation, idReservation, idEcheancierSelectionne).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const state = {
                    stadeSelectionne: {},
                    stamp: Date.now()
                };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this.props.onEnregistrementFiche);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _toggleVerrouEcheancier = (checked) => {

        const ilExisteDesADF = this.props.nbADFReservation > 0;
        const pourcentageCumulMax = Math.max(...this.state.stadesReservation.map(stade => stade.pourcentageCumul), 0);

        if (checked && pourcentageCumulMax < 1) {
            alert("Pourcentage cumulé de l'échéancier non valide. Le dernier pourcentage doit être de 100%.");
        }
        else if (!checked && ilExisteDesADF) {
            //verifie si ADF exists
            alert("Impossible de déverrouiller l'échéancier car il existe des appels de fonds.");
        }
        else {
            const { idOperation, idReservation } = this.props;
            const messageEnCoursTraitement = checked ? "Verrouillage de l'échéancier" : "Déverrouillage de l'échéancier";
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement
            });

            DataReservation._onEnregistrementEcheancierValide(idOperation, idReservation, checked).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null)
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this.props.onEnregistrementFiche);
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
        }
    }

    _estVerrouillageDesactive = () => {
        const { estEcheancierVerrouille, estReservationVerrouillee } = this.props;
        const pourcentageCumulMax = Math.max(...this.state.stadesReservation.map(stade => stade.pourcentageCumul), 0);

        let estDesactive = !estEcheancierVerrouille;

        if (pourcentageCumulMax > 0) {
            if (estReservationVerrouillee) estDesactive = true;
            else if (pourcentageCumulMax >= 1) estDesactive = false;
        }

        return estDesactive;
    };

    _toggleDialog = (nomDialog, isOpen) => () => {
        this.setState({ [`afficherDialog${nomDialog}`]: isOpen });
    };

    componentDidMount = () => {
        const { idOperation, idReservation } = this.props;
        if (!!idOperation && !!idReservation) {
            this._chargementDonnees();
            this._chargementMonCompte();
        }
    };

    componentDidUpdate = (prevProps) => {
        const { idOperation, idReservation } = this.props;
        if (!!idOperation && !!idReservation)
            if (idOperation != prevProps.idOperation || idReservation != prevProps.idReservation)
                this._chargementDonnees();
    };

    render = () => {
        const { peutModifierBlocEcheancier, peutModifierChoixEcheancier, peutSupprimerBlocEcheancier, peutVerrouillerEcheancier } = this.props;
        const { estEcheancierVerrouille, idOperation, idReservation, idEcheancier, nbADFReservation, prixTTC } = this.props;
        const { afficherDialogRemplacement, idEcheancierSelectionne, echeancier, stadeSelectionne, stadesReservation, stamp } = this.state;

        const estStadeSelectionne = !!stadeSelectionne && !!stadeSelectionne.idStade;

        const ilExisteAuMoinsUnAppelDeFonds = nbADFReservation > 0;

        const peutModifier = peutModifierBlocEcheancier && !estEcheancierVerrouille;
        const peutRemplacer = peutModifierChoixEcheancier && !ilExisteAuMoinsUnAppelDeFonds;
        const estVerrouillageDesactive = this._estVerrouillageDesactive();
        const peutVerrouiller = peutModifierBlocEcheancier && peutVerrouillerEcheancier && !estVerrouillageDesactive;

        return <Fragment>

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">

                    <div className="ms-Grid-col ms-sm12 ms-xl8">
                        {!!echeancier && echeancier.nomEcheancier && <div className="labelTitle">{echeancier.nomEcheancier}</div>}
                        <DetailsListReservation_Echeancier_Stade
                            autoriserSuppression={peutSupprimerBlocEcheancier && !estEcheancierVerrouille}
                            idEcheancier={idEcheancier}
                            idOperation={idOperation}
                            idReservation={idReservation}
                            onLoad={items => this.setState({ stadesReservation: items })}
                            prixTTC={prixTTC}
                            stamp={stamp}
                        />
                    </div>

                    <div className="ms-Grid-col ms-sm12 ms-xl4">
                        <div className="blocEcheancierReservation">
                            <div className="titreBlocEcheancierReservation">Verrouiller l'échéancier</div>
                            <Toggle
                                checked={estEcheancierVerrouille}
                                disabled={!peutVerrouiller}
                                inlineLabel
                                label="Echéancier verrouillé"
                                offText="Non"
                                onChange={(e, isChecked) => this._toggleVerrouEcheancier(isChecked)}
                                onText="Oui"
                            />
                        </div>
                        {!estEcheancierVerrouille &&
                            <Fragment>
                                <div className="blocEcheancierReservation">
                                    <div className="titreBlocEcheancierReservation">Ajouter un stade</div>
                                    <ComboBoxOperation_Echeancier_Stade
                                        avecValeurDefaut={false}
                                        disabled={!peutModifier}
                                        hiddenIds={stadesReservation.map(stade => stade.idStade)}
                                        idEcheancier={idEcheancier}
                                        idOperation={idOperation}
                                        idReservation={idReservation}
                                        onChange={this._onChangeStadeSelectionne}
                                        required
                                        selectedKey={stadeSelectionne.idStade}
                                    />
                                    <Stack horizontal gap={8}>
                                        <Stack.Item grow={1}>
                                            <EUIPercentField
                                                disabled
                                                label="Pourcentage"
                                                scale={10}
                                                value={stadeSelectionne.pourcentageAvancementTravaux * 100}
                                            />
                                        </Stack.Item>
                                        <Stack.Item grow={1}>
                                            <EUIPercentField
                                                disabled
                                                label="Cumul"
                                                scale={10}
                                                value={stadeSelectionne.pourcentageCumul * 100}
                                            />
                                        </Stack.Item>
                                    </Stack>
                                    <Stack horizontal gap={8}>
                                        <Stack.Item grow={1}>
                                            <EUINumericField
                                                disabled
                                                label="Montant"
                                                suffix="€"
                                                value={parseFloat(prixTTC * stadeSelectionne.pourcentageAvancementTravaux).toFixed(2)}
                                            />
                                        </Stack.Item>
                                        <Stack.Item grow={1}>
                                            <EUIDatePicker
                                                disabled
                                                label="Date prévisionnelle"
                                                value={stadeSelectionne.datePrevisionnelle}
                                            />
                                        </Stack.Item>
                                    </Stack>
                                    <div className="boutonBlocEcheancierReservation">
                                        <PrimaryButton onClick={this._ajouterStade} disabled={!estStadeSelectionne} className="marginRight8px">Ajouter</PrimaryButton>
                                        <DefaultButton onClick={() => this.setState({ stadeSelectionne: {} })} disabled={!estStadeSelectionne}>Annuler</DefaultButton>
                                    </div>
                                </div>
                                <div className="blocEcheancierReservation">
                                    <div className="titreBlocEcheancierReservation">Remplacer par un échéancier type</div>
                                    <ComboBoxEcheancier
                                        avecValeurDefaut={false}
                                        disabled={!peutRemplacer}
                                        idOperation={idOperation}
                                        onChange={(event, option, index, value, item) => this.setState({ idEcheancierSelectionne: option.key })}
                                        selectedKey={idEcheancierSelectionne}
                                    />
                                    <div className="boutonBlocEcheancierReservation">
                                        <PrimaryButton disabled={!peutRemplacer || !idEcheancierSelectionne} onClick={this._toggleDialog("Remplacement", true)}>Remplacer</PrimaryButton>
                                    </div>
                                </div>
                            </Fragment>
                        }
                    </div>
                </div>
            </div>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="replace" onClick={this._remplacerEcheancier} text="Remplacer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("Remplacement", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogRemplacement}
                message="Attention, vous allez réinitialiser votre échéancier avec les stades de cet échéancier, souhaitez-vous continuer ?"
                onDismiss={this._toggleDialog("Remplacement", false)}
                titre="Remplacement d'un échéancier"
            />
        </Fragment>;
    };

};